import styles from './card.module.css'

import { CardProps } from './card.type'

export const Card = ({ children, className }: CardProps) => {
  return <div className={`${styles.wrapper} ${className}`}>{children}</div>
}
